module.exports = "<div class=\"circular-progress progress-{{ this.percent() }}\"> <div class=\"circular-progress__overlay\"> <span *ngIf=\"growth\">{{ sign() }}</span><span>{{ percent() }}%</span> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/circular-progress/circular-progress.component.html
// module id = ./src/app/shared/components/circular-progress/circular-progress.component.html
// module chunks = 21